module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_3.462e4175.png";